import dayjs from 'dayjs';

function buildPrepSheetExportBasename(dateRange, extension) {
  const start = dateRange?.[0]?.format('YYYY-MM-DD');
  const end = dateRange?.[1]?.format('YYYY-MM-DD');
  const generated = dayjs().format('YYYY-MM-DD');

  if (start && end) {
    if (start === end) {
      return `prep-sheet_${start}_${generated}.${extension}`;
    }
    return `prep-sheet_${start}_to_${end}_${generated}.${extension}`;
  }

  return `prep-sheet_${generated}.${extension}`;
}

export function buildPrepSheetCsvFilename(dateRange) {
  return buildPrepSheetExportBasename(dateRange, 'csv');
}

export function buildPrepSheetPdfFilename(dateRange) {
  return buildPrepSheetExportBasename(dateRange, 'pdf');
}
